@if (isHrefNavigation()) {
  @if (disabled()) {
    <a
      (click)="stopPropagation() ? $event.stopPropagation() : undefined"
      class="anchor-button__anchor"
      [class.disabled]="disabled()"
    >
      <ng-container *ngTemplateOutlet="hrefContent"></ng-container>
    </a>
  } @else {
    @if (navigation() === '') {
      <a (click)="onEmptyAnchorClick($event)" class="anchor-button__anchor" [class.disabled]="disabled()">
        <ng-container *ngTemplateOutlet="hrefContent"></ng-container>
      </a>
    } @else {
      <a
        [href]="navigation()"
        (click)="stopPropagation() ? $event.stopPropagation() : undefined"
        class="anchor-button__anchor"
        [class.disabled]="disabled()"
        target="_blank"
      >
        <ng-container *ngTemplateOutlet="hrefContent"></ng-container>
      </a>
    }
  }
} @else {
  <a (click)="onClick($event)" class="anchor-button__anchor" [class.disabled]="disabled()">
    <ng-container *ngTemplateOutlet="hrefContent"></ng-container>
  </a>
}
<ng-template #hrefContent>
  <ng-content></ng-content>
</ng-template>
